// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_DELETE_AUTO,
} from './constants';

export function deleteAuto(id) {
  return {
    type: SIMULADOR_FINANCIERO_DELETE_AUTO,
    id: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_DELETE_AUTO:
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        editLineaData.asignacionLineas.lineas.forEach((linea) => {
          if (linea.id === action.id && !linea.newLinea) {
            editLineaData.asignacionLineas.lineasDeleted.push({ ...linea });
          }
        })
        let lineas = state.editLineaData.asignacionLineas.lineas.filter((value, index, arr) => {
          return value.id !== action.id;
        });
        editLineaData.asignacionLineas.lineas = lineas;

        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let lineas = state.altaNuevaLinea.asignacionLineas.lineas.filter((value, index, arr) => {
          return value.id !== action.id;
        });
        altaNuevaLinea.asignacionLineas.lineas = lineas;

        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }

    default:
      return state;
  }
}
